import JSXComponent from "../../../dist/jsx-render/JSXComponent";
import dom from "../../../dist/jsx-render/dom";
import { User } from "../../Areas/Admin/User/UserEdit/Models/User";
import { app } from "../../Frame/App";
import { DropDownComponentProps, DropDownComponent, OnDropDownChange } from "../DropDownComponent";
import { IDropdown } from "../Interfaces/IDropdown";

export type UserDropdownComponentProps = {
    model: any;
    field: string;

    /** If you provide a friendlyValueField on the model, the name of the user will be written into it. 
     * Use it to display the username outside of the control. */
    friendlyValueField?: string;
    name?: string;

    /** If you provide a collection of users, this will be used instead of
     * getting the users by an ajax call. */
    users?: User[];

    onChange?: OnDropDownChange;
    addEmptyItem?: boolean;

    /** Additional items that are added after the control gets the items from the server. */
    additionalItems?: Array<any>;
    additionalItemsOnTop?: boolean;
}

/** 
 * A component that displays a dropdown of users and writes the selected user id into a
 * specified field of the model. You can determine the model field by providing the property "field".
 * */
export class UserDropdownComponent extends JSXComponent implements IDropdown {
    props: UserDropdownComponentProps;
    constructor(props: UserDropdownComponentProps) { super(props); }

    dropdownRef: DropDownComponent;

    userUrl: string = "~/api/Users/getList";

    handleChange = (control: DropDownComponent) => {
        if (this.props.onChange) {
            this.props.onChange(this.dropdownRef);
        }
        this.updateModelFromControl(this.dropdownRef);
    }

    private updateModelFromControl = (control: DropDownComponent) => {
        let selectedItem = control.getSelectedItem();
        if (selectedItem) {
            this.props.model.setPropertyByPath(this.props.field, Number(selectedItem.id));
        } else {
            this.props.model.setPropertyByPath(this.props.field, undefined);
        }

        if (this.props.friendlyValueField) {
            if (selectedItem) {
                this.props.model.setPropertyByPath(this.props.friendlyValueField, selectedItem.name);
            } else {
                this.props.model.setPropertyByPath(this.props.friendlyValueField, undefined);
            }
        }
    }

    getSelectedValue = () => {
        let selectedValue = this.dropdownRef.getSelectedItem()?.id;
        return (selectedValue === undefined || selectedValue === null) ? 0 : selectedValue;
    }

    setValue = (value: string): void => {
        this.dropdownRef.setValue(value);
    }

    removeSelection = () => {
        this.dropdownRef.removeSelection();
        this.updateModelFromControl(this.dropdownRef);
    }

    addEventListener = (listener: OnDropDownChange) => {
        this.dropdownRef.addEventListener(listener);
    }

    element: HTMLElement;
    getElement = () => {
        let dropdownProps: DropDownComponentProps = {
            displayProperty: "name",
            valueProperty: "id",
            id: app.createRadomizedLetters(10),
            childrenProperty: "children",
            items: this.props.users,
            url: this.userUrl,
            onChange: this.handleChange,
            expandAll: true,
            addEmptyItem: this.props.addEmptyItem,
            additionalItems: this.props.additionalItems

        }
        this.dropdownRef = new DropDownComponent(dropdownProps);

        this.element = <div className="user-field form-group">
            {this.props.name
                ? <label className="form-label">{this.props.name}</label>
                : []}
            {this.dropdownRef.render()}
        </div>;
    }

    getSelectedItem = (): any => {
        return this.dropdownRef.getSelectedItem();
    }

    render() {
        this.getElement();

        if (this.props.model[this.props.field] !== undefined && this.props.model[this.props.field] !== null) {
            this.dropdownRef.setValue(this.props.model[this.props.field].toString());
        }

        return this.element;
    }
}